import heroPosterMain from "E:/MyWork/LightSlice/docs/上架资料/16-9主图.png";
import promo30 from "E:/MyWork/LightSlice/docs/上架资料/3.0宣传图.png";
import promoTrailer from "E:/MyWork/LightSlice/docs/上架资料/宣传片.mp4";
import heroBackdropRuinScene3 from "E:/MyWork/LightSlice/game_shared/resources/images/ruin_scene3.png";
import heroBackdropRuinScene5 from "E:/MyWork/LightSlice/game_shared/resources/images/ruin_scene5.png";
import heroPortraitFeiFei from "E:/MyWork/LightSlice/game_shared/src/assets/images-optimized/fei_fei_p1.jpg";
import heroPortraitLinYa from "E:/MyWork/LightSlice/game_shared/src/assets/images-optimized/lin_ya_p1.jpg";
import bossSuP1 from "E:/MyWork/LightSlice/game_shared/src/assets/images-optimized/boss_su_p1.jpg";
import notebookBoardNow from "E:/MyWork/LightSlice/docs/上架资料/NotebookLM/上车宣传.png";
import notebookModEditorEntry from "E:/MyWork/LightSlice/docs/上架资料/Mod编辑器宣传/官网-mod编辑器入口.png";
import modEditorAssetLibraryGame from "E:/MyWork/LightSlice/docs/上架资料/Mod编辑器宣传/官网-mod编辑器-内置素材库（游戏同源）.png";
import modEditorAssetLibraryAudio from "E:/MyWork/LightSlice/docs/上架资料/Mod编辑器宣传/官网-mod编辑器-内置素材库（音效音乐）.png";
import modEditorNpc from "E:/MyWork/LightSlice/docs/上架资料/Mod编辑器宣传/官网-mod编辑器-自定义NPC.png";
import modEditorEvent from "E:/MyWork/LightSlice/docs/上架资料/Mod编辑器宣传/官网-mod编辑器-自定义剧情事件.png";
import modEditorChatFlow from "E:/MyWork/LightSlice/docs/上架资料/Mod编辑器宣传/官网-mod编辑器-自定义微信聊天树.png";
import modEditorNews from "E:/MyWork/LightSlice/docs/上架资料/Mod编辑器宣传/官网-mod编辑器-自定义新闻.png";
import modEditorMoments from "E:/MyWork/LightSlice/docs/上架资料/Mod编辑器宣传/官网-mod编辑器-自定义朋友圈.png";
import modEditorItems from "E:/MyWork/LightSlice/docs/上架资料/Mod编辑器宣传/官网-mod编辑器-自定义物品.png";
import notebookGuitar from "E:/MyWork/LightSlice/docs/上架资料/NotebookLM/菲菲弹吉他.png";
import notebookPromo169 from "E:/MyWork/LightSlice/docs/上架资料/NotebookLM/宣传图16-9.png";
import notebookPromoPoster from "E:/MyWork/LightSlice/docs/上架资料/NotebookLM/宣传截图/0.png";
import notebookPromo40 from "E:/MyWork/LightSlice/docs/上架资料/NotebookLM/宣传截图/4.0-1.png";
import notebookPromoCoreStock from "E:/MyWork/LightSlice/official_site/src/assets/core-gameplay/core-stock.webp";
import notebookPromoCoreCardBattle from "E:/MyWork/LightSlice/official_site/src/assets/core-gameplay/core-card-battle.webp";
import notebookPromoCoreRvUpgrade from "E:/MyWork/LightSlice/official_site/src/assets/core-gameplay/core-rv-upgrade.webp";
import notebookPromoCoreRoguelike from "E:/MyWork/LightSlice/official_site/src/assets/core-gameplay/core-roguelike.webp";
import screenshotRv from "E:/MyWork/LightSlice/docs/上架资料/截图/1.0/房车.jpg";
import screenshotWechatContacts from "E:/MyWork/LightSlice/docs/上架资料/截图/1.0/微信联系人.jpg";
import screenshotMoments from "E:/MyWork/LightSlice/docs/上架资料/截图/1.0/朋友圈.jpg";
import screenshotRuinsExplore from "E:/MyWork/LightSlice/docs/上架资料/截图/3.0/废墟探索1.jpg";
import screenshotDispatch from "E:/MyWork/LightSlice/docs/上架资料/截图/3.0/小队派遣.jpg";
import screenshotSettlement from "E:/MyWork/LightSlice/docs/上架资料/截图/3.0/日结面板.jpg";
import update385 from "E:/MyWork/LightSlice/docs/上架资料/更新/3.8.5更新内容.png";
import update38Part1 from "E:/MyWork/LightSlice/docs/上架资料/更新/3.8更新内容1.png";
import update36 from "E:/MyWork/LightSlice/docs/上架资料/更新/3.6 更新内容.png";
import update35 from "E:/MyWork/LightSlice/docs/上架资料/更新/3.5更新内容.png";
import updateBossEntrance from "E:/MyWork/LightSlice/docs/上架资料/更新/boss入场.jpg";
import updateKitchen from "E:/MyWork/LightSlice/docs/上架资料/更新/末世厨房.jpg";
import updateHydroponics from "E:/MyWork/LightSlice/docs/上架资料/更新/水培农场.jpg";
import destinyWancang from "E:/MyWork/LightSlice/docs/上架资料/更新/命途-万藏.jpg";
import guideCardBattle from "E:/MyWork/LightSlice/docs/新手引导攻略/卡牌战斗新手教学.pdf";
import guideCardBoss from "E:/MyWork/LightSlice/docs/新手引导攻略/精英挑战&守关BOSS.pdf";
import musicP2Combat from "E:/MyWork/LightSlice/game_shared/resources/music/bak/bgm_p2_combat.mp3";
import musicP2Combat2 from "E:/MyWork/LightSlice/game_shared/resources/music/bak/bgm_p2_combat2.mp3";
import musicCrazy from "E:/MyWork/LightSlice/game_shared/resources/music/bak/疯狂的先知.mp3";
import musicDownCounter from "E:/MyWork/LightSlice/game_shared/resources/music/bak/午夜倒计时.wav";
import musicMryyzn from "E:/MyWork/LightSlice/game_shared/resources/music/bak/末日优雅生存指南.wav";

const imageMap: Record<string, string> = {
  'hero_main': heroPosterMain,
  'promo_30': promo30,
  'promo_40': notebookPromo40,
  'promo_core_stock': notebookPromoCoreStock,
  'promo_core_card_battle': notebookPromoCoreCardBattle,
  'promo_core_rv_upgrade': notebookPromoCoreRvUpgrade,
  'promo_core_roguelike': notebookPromoCoreRoguelike,
  'board_now': notebookBoardNow,
  'guitar_live': notebookGuitar,
  'poster_0': notebookPromoPoster,
  'promo_169': notebookPromo169,
  'mod_editor_entry': notebookModEditorEntry,
  'mod_editor_chat_flow': modEditorChatFlow,
  'mod_editor_npc': modEditorNpc,
  'mod_editor_event': modEditorEvent,
  'mod_editor_news': modEditorNews,
  'mod_editor_moments': modEditorMoments,
  'mod_editor_items': modEditorItems,
  'mod_editor_asset_library_game': modEditorAssetLibraryGame,
  'mod_editor_asset_library_audio': modEditorAssetLibraryAudio,
  'ruin_scene5': heroBackdropRuinScene5,
  'ruin_scene3': heroBackdropRuinScene3,
  'lin_ya_p1': heroPortraitLinYa,
  'fei_fei_p1': heroPortraitFeiFei,
  'boss_su_p1': bossSuP1,
  '房车': screenshotRv,
  '微信联系人': screenshotWechatContacts,
  '朋友圈': screenshotMoments,
  '废墟探索1': screenshotRuinsExplore,
  '小队派遣': screenshotDispatch,
  '日结面板': screenshotSettlement,
  '3.8.5更新内容': update385,
  '3.8更新内容1': update38Part1,
  '3.6 更新内容': update36,
  '3.5更新内容': update35,
  'boss入场': updateBossEntrance,
  '末世厨房': updateKitchen,
  '水培农场': updateHydroponics,
  '命途-万藏': destinyWancang,
};

const documentMap: Record<string, string> = {
  '卡牌战斗新手教学': guideCardBattle,
  '精英挑战&守关boss': guideCardBoss,
};

const videoMap: Record<string, string> = {
  'official_trailer': promoTrailer,
};

const audioMap: Record<string, string> = {
  'bgm_p2_combat': musicP2Combat,
  'bgm_p2_combat2': musicP2Combat2,
  'crazy': musicCrazy,
  'downcounter': musicDownCounter,
  'mryyzn': musicMryyzn,
};

export function getSiteImage(key: string) {
  return imageMap[key.trim().toLowerCase()] ?? '';
}

export function getSiteDocument(key: string) {
  return documentMap[key.trim().toLowerCase()] ?? '';
}

export function getSiteVideo(key: string) {
  return videoMap[key.trim().toLowerCase()] ?? '';
}

export function getSiteAudio(key: string) {
  return audioMap[key.trim().toLowerCase()] ?? '';
}
